// extracted by mini-css-extract-plugin
module.exports = {"icon":"AttachmentModal_icon__11f9c","disable":"AttachmentModal_disable__39SUH"};